var modal = function () {
  var modals = document.querySelectorAll(".modal-form"); // Toutes les modales

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("toggle-modal")) {
      show(document.querySelector("#form")); // Ouvre la modale principale
    }
    if (
      e.target.classList.contains("close-modal") ||
      e.target.id === "close-modal"
    ) {
      hide();
    }
  });
/**
 * Affiche la modale
 * @param {HTMLElement} modalToShow - La modale à afficher
 */
  function show(modalToShow) {
    hide(); // Ferme toute autre modale ouverte
    
    // Sauvegarder la position de scroll actuelle
    var scrollY = window.scrollY || window.pageYOffset;
    document.body.style.top = '-' + scrollY + 'px';
    
    modalToShow.classList.add("active");
    document.body.classList.add("no-scroll");
  }

/**
 * Ferme la modale
 */ 
  function hide() {
    modals.forEach(function (modal) {
      return modal.classList.remove("active");
    });
    
    // Restaurer la position de scroll sans scroll visible
    var scrollY = document.body.style.top;
    document.body.classList.remove("no-scroll");
    document.body.style.top = '';
    
    // Restaurer la position sans animation de scroll
    if (scrollY) {
      var targetY = parseInt(scrollY || '0') * -1;
      // Utiliser scrollTo avec behavior: 'instant' pour éviter l'animation
      if (window.scrollTo) {
        window.scrollTo({ top: targetY, behavior: 'instant' });
      } else {
        // Fallback pour les navigateurs plus anciens
        window.scrollTo(0, targetY);
      }
    }
  }
};

modal();

var choix;

var form = {
  init: function () {
    this.form = document.querySelector("#form form"); // Formulaire principal
    this.handleEvents();
  },

  handleEvents: function () {
    var this$1 = this;

    this.form.addEventListener("click", function (e) {
      if (e.target.classList.contains("toggle-step")) {
        if (e.target.id === "ets") {
          e.target.dataset.info = 1;
          if (document.getElementById("struct-legale")) {
            document
              .getElementById("struct-legale")
              .setAttribute("data-info", "1");
          }
          // Forcer le bon endpoint CF7 pour ETS (617)
          var formEl = document.getElementById('form-reservation');
          if (formEl) {
            formEl.setAttribute('action', '/wp-json/contact-form-7/v1/contact-forms/617/feedback');
          }
          
          // En mobile: afficher toutes les étapes du flux ETS et masquer celles d'Autre
          if (window.innerWidth <= 768) {
            // Afficher les étapes ETS
            document.querySelectorAll('#form-ets-step-1, #ets-form, #struct-legale').forEach(step => {
              step.classList.add('flow-selected');
            });
            // Masquer les étapes Autre
            document.querySelectorAll('#form-other-step-1, #autre-form, #autre-struct-legale').forEach(step => {
              step.classList.remove('flow-selected');
            });

            // Désactiver les champs du flux Autre, activer ceux du flux ETS
            toggleFlowFields({ enable: ['#form-ets-step-1', '#ets-form', '#struct-legale'], disable: ['#form-other-step-1', '#autre-form', '#autre-struct-legale'] });
          }
        }
        if (e.target.id === "autre") {
          e.target.dataset.info = 1;
          if (document.getElementById("struct-legale")) {
            document
              .getElementById("struct-legale")
              .setAttribute("data-info", "0");
          }
          // Forcer le bon endpoint CF7 pour Autre (618)
          var formEl2 = document.getElementById('form-reservation');
          if (formEl2) {
            formEl2.setAttribute('action', '/wp-json/contact-form-7/v1/contact-forms/618/feedback');
          }
          
          // En mobile: afficher toutes les étapes du flux Autre et masquer celles d'ETS
          if (window.innerWidth <= 768) {
            // Afficher les étapes Autre
            document.querySelectorAll('#form-other-step-1, #autre-form, #autre-struct-legale').forEach(step => {
              step.classList.add('flow-selected');
            });
            // Masquer les étapes ETS
            document.querySelectorAll('#form-ets-step-1, #ets-form, #struct-legale').forEach(step => {
              step.classList.remove('flow-selected');
            });

            // Désactiver les champs du flux ETS, activer ceux du flux Autre
            toggleFlowFields({ enable: ['#form-other-step-1', '#autre-form', '#autre-struct-legale'], disable: ['#form-ets-step-1', '#ets-form', '#struct-legale'] });
          }
        }
        this$1.changeStep(e.target);
      }
    });
  },

  changeStep: function (e) {
    var currentStep = this.form.querySelector(".form-step.current");
    var currentStepNumber = currentStep
      ? parseInt(currentStep.dataset.step)
      : null;
    var targetStep = parseInt(e.dataset.toggle);

    // Vérification si on veut aller vers "autre structure" (étape 4)
    if (targetStep === 4) {
      openAutreStructureModal();
      return;
    }
    if (this.validateStep(currentStepNumber)) {
      this.reset();
      var newStep = this.form.querySelector(
        ".form-step[data-step='" + targetStep + "']"
      );
      if (newStep && !newStep.classList.contains("current")) {
        if (targetStep === 1) {
          choix =
            document.getElementById("ets").getAttribute("data-info") === "1"
              ? "ets"
              : "autre";
          if (choix === "ets") {
            // document.getElementById("form-step").remove();
            if (document.getElementById("form-other-step-1")) {
              document.getElementById("form-other-step-1").remove();
            }

            document.getElementById("form-ets-step-1").classList.add("current");
          } else {
            document
              .getElementById("form-other-step-1")
              .classList.add("current");
          }
        }

        if (targetStep === 2) {
          if (choix === "ets") {
            if (document.getElementById("autre-form")) {
              document.getElementById("autre-form").remove();
            }
            document.getElementById("ets-form").classList.add("current");
          } else {
            var url = document
              .getElementById("form-reservation")
              .getAttribute("action");
            url = url.replace("617", "618");
            document
              .getElementById("form-reservation")
              .setAttribute("action", url);
            if (document.getElementById("ets-form")) {
              document.getElementById("ets-form").remove();
            }
            document.getElementById("autre-form").classList.add("current");
          }
        }
        // Code affiche texte mentions légales en fonction étape
        if (targetStep === 3) {
          if (choix === "ets") {
            if (document.getElementById("autre-struct-legale")) {
              document.getElementById("autre-struct-legale").remove();
            }

            document.getElementById("struct-legale").classList.add("current");
          } else {
            if (document.getElementById("struct-legale")) {
              document.getElementById("struct-legale").remove();
            }

            document
              .getElementById("autre-struct-legale")
              .classList.add("current");
          }
        }
        newStep.classList.add("current");
      }
    }
  },

  validateStep: function (stepNumber) {
    switch (stepNumber) {
      case 0:
        return true; // Pas de validation pour step 0
      case 1:
        return this.validateStepOne();
      default:
        return true;
    }
  },

  validateStepOne: function () {
    var stepOne = this.form.querySelector('.form-step[data-step="1"]');
    
    // Déterminer quel flux est actif (ETS ou Autre)
    var isEtsFlow = stepOne.querySelector('#form-ets-step-1') && stepOne.querySelector('#form-ets-step-1').classList.contains('flow-selected');
    var isOtherFlow = stepOne.querySelector('#form-other-step-1') && stepOne.querySelector('#form-other-step-1').classList.contains('flow-selected');
    
    // Sélectionner la bonne table selon le flux
    var targetTable = null;
    var errorMessage = null;
    
    if (isEtsFlow) {
      targetTable = stepOne.querySelector(".table_zone");
      errorMessage = stepOne.querySelector(".table_zone .errorMessage");
    } else if (isOtherFlow) {
      targetTable = stepOne.querySelector(".table_zone_2");
      errorMessage = stepOne.querySelector(".table_zone_2 .errorMessage");
    }
    
    // Créer le message d'erreur si nécessaire
    if (!errorMessage && targetTable) {
      errorMessage = document.createElement("div");
      errorMessage.className = "errorMessage";
      targetTable.appendChild(errorMessage);
    }
    
    // Vérifier les périodes sélectionnées dans la table appropriée
    var selectedPeriods = targetTable ? targetTable.querySelectorAll(".periode.selectable.selected") : [];
    
    // Vérifier aussi les champs cachés (fallback)
    var zoneInput = stepOne.querySelector('input[name="zone"]');
    var periodesInput = stepOne.querySelector('input[name="periodes"]');
    var hasZoneValue = zoneInput && zoneInput.value.trim() !== '';
    var hasPeriodesValue = periodesInput && periodesInput.value.trim() !== '';
    
    // Validation : soit des périodes visuellement sélectionnées, soit des valeurs dans les champs cachés
    var isValid = selectedPeriods.length > 0 || (hasZoneValue && hasPeriodesValue);
    
    if (!isValid) {
      if (errorMessage) {
        errorMessage.innerHTML = "Veuillez sélectionner une zone et au moins une période.";
        errorMessage.classList.add("active");
      }
      return false;
    } else {
      if (errorMessage) {
        errorMessage.innerHTML = "";
        errorMessage.classList.remove("active");
      }
      return true;
    }
  },

  reset: function () {
    var current = this.form.querySelector(".form-step.current");
    if (current) {
      current.classList.remove("current");
    }
  },
};

// Initialiser la navigation de formulaire sur toutes les tailles d'écran (mobile et desktop)
document.addEventListener('DOMContentLoaded', function () {
  // Préparer les champs: stocker le name original (sécurisé même si on ne le retire plus)
  var rootForm = document.getElementById('form-reservation');
  if (rootForm) {
    rootForm.querySelectorAll('input, select, textarea').forEach(function (el) {
      if (el.name && !el.dataset.origName) {
        el.setAttribute('data-orig-name', el.name);
      }
    });
  }

  // Fonction utilitaire pour activer/désactiver les champs selon le flux choisi (mobile)
  window.toggleFlowFields = function (opts) {
    var enableSel = (opts && opts.enable) || [];
    var disableSel = (opts && opts.disable) || [];

    var enableScopes = enableSel.map(function (s) { return document.querySelector(s); }).filter(Boolean);
    var disableScopes = disableSel.map(function (s) { return document.querySelector(s); }).filter(Boolean);

    // Activer: restaurer disabled=false; required sera géré par reservation.js
    enableScopes.forEach(function (scope) {
      scope.querySelectorAll('input, select, textarea').forEach(function (el) {
        el.disabled = false;
      });
    });

    // Désactiver: mettre disabled=true pour que CF7 n'envoie pas ces champs, et retirer required
    disableScopes.forEach(function (scope) {
      scope.querySelectorAll('input, select, textarea').forEach(function (el) {
        el.disabled = true;
        // Éviter erreurs HTML5
        if (el.hasAttribute('required')) {
          el.setAttribute('data-was-required', '1');
          el.removeAttribute('required');
        }
      });
    });
  };

  form.init();
});



// WEBPACK FOOTER //
// ./scripts/formulaire.js